// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"7743eb05","487":"ce2a3c0c","858":"55b132ad","864":"eaa39689","917":"04cdf857"}[chunkId] + ".chunk.js";
};